export const parseHTML = (html) => {
    var t = document.createElement('template');
    t.innerHTML = html;
    return t.content;
};

export default parseHTML;
